import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import InfoMessage from '@swf/components/InfoMessage/InfoMessage';
import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import { StatusCode } from '@swf/core/enums/statusCode';

import { ExclusionTime } from '../../../shared/definitions';
import AccountDate from '../../AccountDate/AccountDate';
import { ExclusionType } from '../../definitions';
import { ExclusionResponseWithdrawalMessage } from '../ExclusionResponseWithdrawalMessage/ExclusionResponseWithdrawalMessage';

import {
  TXTWCL_After_N0_monthsX_if_you_want_t_ELL,
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_14,
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_5,
  TXTWCL_WeXll_automatically_reopen_you_ELL,
  TXTWCL_WeXll_automatically_reopen_you_ELL_1,
  TXTWCL_We_canXt_process_your_request__ELL_1,
  TXTWCL_YouXre_self_excluded_indefinit_ELL,
  TXTWCL_YouXre_taking_a_break
} from './ExclusionResponseUSPA.messages.json';

interface Props {
  error?: boolean;
  statusCode?: StatusCode;
  endDate: Date;
  daysRequested?: number;
  exclusionType?: ExclusionType;
}

const IndefiniteExclusionMessage = () => (
  <div>
    <Translation {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_14} />{' '}
    <Translation
      {...TXTWCL_After_N0_monthsX_if_you_want_t_ELL}
      values={{
        0: ExclusionTime.TwelveMonths,
        a: (msg: React.ReactNode) => (
          <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
        )
      }}
    />{' '}
    <ExclusionResponseWithdrawalMessage />
  </div>
);

const ExclusionResponseUSPA: React.FC<Props> = ({
  error,
  statusCode,
  endDate,
  daysRequested,
  exclusionType
}) => {
  const formattedEndDate = (
    <b>
      <AccountDate date={endDate} />
    </b>
  );

  switch (true) {
    case error:
      return (
        <InfoMessage type="error">
          <Translation {...TXTWCL_We_canXt_process_your_request__ELL_1} />
        </InfoMessage>
      );
    case statusCode === StatusCode.USER_SELF_EXCLUDED:
      return daysRequested ? (
        <InfoMessage type="confirmation" messageTitle={TXTWCL_YouXre_taking_a_break}>
          <div>
            <Translation
              {...TXTWCL_WeXll_automatically_reopen_you_ELL_1}
              values={{ 0: formattedEndDate }}
            />{' '}
            <ExclusionResponseWithdrawalMessage />
          </div>
        </InfoMessage>
      ) : (
        <InfoMessage type="confirmation" messageTitle={TXTWCL_YouXre_self_excluded_indefinit_ELL}>
          <IndefiniteExclusionMessage />
        </InfoMessage>
      );
    default:
      return exclusionType === ExclusionType.Break ? (
        <>
          <Translation
            {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_5}
            values={{ 0: formattedEndDate }}
          />{' '}
          <Translation {...TXTWCL_WeXll_automatically_reopen_you_ELL} />{' '}
          <ExclusionResponseWithdrawalMessage useLongMessage />
        </>
      ) : (
        <IndefiniteExclusionMessage />
      );
  }
};

export default ExclusionResponseUSPA;
